export type FormValues = {
    settlementDate: string;
};

export const getInitialValues = (): FormValues => ({
    settlementDate: '',
});
